window.__vite_import_meta=import.meta;